<template>
    <div>
        <div class="d-flex flex-column question">
            <div class="text-muted mr-1 mb-1">Question:</div>
            
            <TipTap
                v-model="question.content.question"
                :menu_items="[]"
                :readonly="true"
            />
            
            <div class="d-flex flex-column">
                <div class="text-muted mr-1 mb-1">Blank Answers:</div>
                <div v-for="(blank, index) in question.content.blanks">
                    <div class="mt-3">
                        <div>
                            <span>{{ blank.blank_id }}.</span> 
                            <template>
                                <span v-if="blank.answer && blank.options && blank.options.length < 1"> Exact Answer Required: {{ blank.answer }}</span>
                                <span v-if="blank.options && blank.options.length > 0 && !blank.is_open_response"> Correct Option: {{ blank.answer }}</span>
                                <span v-if="blank.is_open_response"> Answers Will Vary: {{ blank.suggested_answers }}</span>
                            </template>
                        </div>    
                        <div v-if="blank.is_open_response === true " class="badge badge-warning m-3"> Graded By Teacher </div>
                        <div v-if="blank.is_open_response !== true " class="badge badge-primary m-3"> Auto Graded </div>

                        <template>
                            <div v-if="blank.options && blank.options.length > 0 && !blank.is_open_response" class="text-muted mb-2 ml-4">Options: </div>
                            <div v-if="blank.is_open_response && blank.suggested_answers" class="text-muted mb-2 ml-4">Suggested Answer(s): {{ blank.suggested_answers }}</div>
                            <div v-if="blank.is_open_response && blank.suggested_answers" class="text-muted mb-2 ml-4"> Answers Character Limit: {{ blank.open_response_limit }}</div>
                        </template>

                        <b-list-group v-if="!blank.is_open_response" class="ml-4">
                            <b-list-group-item
                                v-for="(option, index) in blank.options"
                                :key="index"
                                :class="{'d-flex align-items-center': option.option, 'd-none': !option.option}"
                            >
                                <div :class="{'text-success': blank.answer == option.option}">
                                    <span v-if="blank.answer == option.option">
                                        <font-awesome-icon :icon="['fad', 'check-square']" />
                                    </span>
                                    <span>{{'  ' +option.option}}</span>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<style lang="scss">
.question {
    .blank:before {
        content: '________'
    }
}

table {
    width: 100%;
}

table td {
    border: 1px solid #999;
    padding: 1em;
}
</style>

<script>
export default {
    data: () => ({}),
    props: ['question'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
    },
    methods: {
        saveQuestion () {
            this.$emit('saveQuestion')
        }
    }
}
</script>
